import React from "react";
import { NavLink } from "react-router-dom";


import './style.css'
import Divider from "src/components/Divider";

export const Footer = ({ style }) => {
  return (
    <section className={'footer'} style={{ ...style, background: '#EEF2F6' }}>
      <div className="container">
        <div className="row">
          <NavLink to='/'>
            <img src="/images/logo-ajg.png" width={185} alt="" />
          </NavLink>
        </div>
        <Divider style={{ background: '#1D1D294D' }} />
        <div className="row mob-hide ">
          <a target='_blank' className='footer-link-item' href="https://www.ajg.com/uk/global-privacy-notice/" rel="noreferrer">Privacy policy</a>
          <a target='_blank' className='footer-link-item' href="https://www.ajg.com/uk/legal-and-regulatory-information/" rel="noreferrer">Terms of Use</a>
        </div>



        <div id="bottom-page" className="row"></div>
      </div>
    </section>


  )
}
